import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoginSelectionScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-600 flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl p-8 w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Login to CollegeSphere</h2>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/login?role=student')}
            className="w-full bg-purple-600 text-white py-3 rounded-lg font-bold hover:bg-purple-700 transition-all duration-300 transform hover:scale-105"
          >
            Student Login
          </button>

          <button
            onClick={() => navigate('/login?role=admin')}
            className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold hover:bg-indigo-700 transition-all duration-300 transform hover:scale-105"
          >
            Club Admin Login
          </button>

          <button
            onClick={() => navigate('/login?role=superadmin')}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold hover:bg-blue-700 transition-all duration-300 transform hover:scale-105"
          >
            Super Admin Login
          </button>

          <hr className="my-6" />

          <button
            onClick={() => navigate('/register')}
            className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition-all duration-300 transform hover:scale-105"
          >
            Register (Students Only)
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginSelectionScreen;
